import { clientLog } from './logs';
import { NikeLog } from '../../types/generated/nike-log';

let MAX_BUFFER_SIZE = 10000;
let MAX_LOG_LIFETIME_MILLIS = 15 * 60 * 1000;
let logBuffers = {};

function filterOldLogs() {
    const now = Date.now();
    return (item: NikeLog.ClientLog) => {
        const logLifeTime = now - item.clientTimestamp;
        // true keeps item in array
        return logLifeTime <= MAX_LOG_LIFETIME_MILLIS;
    };
}

export function bufferClientLog(bufferKey: string, log: NikeLog.ClientLog) {
    // dont midify existing object
    let buffer = logBuffers[bufferKey] || [];
    buffer.push(log);

    buffer = buffer.filter(filterOldLogs());

    if (buffer.length > MAX_BUFFER_SIZE) {
        buffer.shift();
    }

    logBuffers[bufferKey] = buffer;
}

export function flushClientLogs(bufferKey) {
    if (!logBuffers[bufferKey]) {
        return;
    }
    clientLog(logBuffers[bufferKey]);
    logBuffers[bufferKey] = undefined;
}

// test only stuff:
function getBuffer(bufferKey) {
    return logBuffers[bufferKey];
}

function setMaxBufferSize(value) {
    MAX_BUFFER_SIZE = value;
}

function setMaxLogLifetimeMillis(value) {
    MAX_LOG_LIFETIME_MILLIS = value;
}

export let _testOnly = {
    setMaxBufferSize,
    setMaxLogLifetimeMillis,
    getBuffer
};
